import { memo, useState } from 'react';
import { StyleSheet, Text, View, Pressable, Image } from 'react-native';
import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

export default memo(function (props) {
  const collapsable = props.collapsable === true;

  const [collapsed, setCollapsed] = useState(false);

  function handleArrowPress() {
    setCollapsed(!collapsed);
  }

  return (
    <View style={[styles.sectionContainer, props.containerStyle]} onLayout={props.onLayout}>
      {(!!props.title || !!props.extraHeaderContent) && (
        <View style={[styles.panelHeader, props.headerStyle]}>
          {!!props.title && (
            <Text style={[styles.headerText, props.labelStyle]}>{props.title}</Text>
          )}
          {!!props.extraHeaderContent && props.extraHeaderContent}
          {!!collapsable && (
            <Pressable style={styles.arrowBtn} onPress={handleArrowPress}>
              <Image
                style={[
                  styles.icon,
                  !collapsed
                    ? {
                        transform: [{ rotate: '180deg' }],
                      }
                    : null,
                ]}
                source={require('../../../resources/arrow-down.png')}
              />
            </Pressable>
          )}
        </View>
      )}
      {!collapsed && props.children}
    </View>
  );
});

const styles = StyleSheet.create({
  headerText: __WEB__
    ? {
        flexGrow: 1,
        ...THEME.textSemibold,
        fontSize: 16,
        paddingVertical: 15,
        paddingHorizontal: 15,
        color: COLOR.text,
      }
    : {
        flexGrow: 1,
        ...THEME.textSemibold,
        fontSize: 14,
        color: 'rgb(5, 5, 5)',
        paddingVertical: 15,
        paddingHorizontal: 15,
      },
  sectionContainer: {
    borderWidth: 1,
    borderColor: COLOR.altAccent,
    minWidth: 300,
    shadowColor: 'rgba(0, 0, 0, .1)',
    shadowOffset: { width: 0, height: 3 },
    shadowRadius: 9,
    margin: __WEB__ ? 10 : 0,
    marginBottom: 30,
    overflow: 'hidden',
  },
  panelHeader: {
    flexDirection: 'row',
    backgroundColor: COLOR.altContrast,
    borderBottomWidth: 1,
    borderColor: COLOR.altAccent,
    alignItems: 'center',
  },
  arrowBtn: {
    width: 60,
    alignSelf: 'stretch',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 14,
    height: 14,
    tintColor: '#AAA',
  },
});
